<!-- 新的产品详情页，旧的页面是productDetailOld -->
<template>
  <div class="productDetailBox">
    <div class="continer">
      <div class="top">
        <div class="productDetail">
          <div class="pics"><img :src="productData.appLogoUrl" alt=""></div>
          <p> {{ productData.productName }} </p>
        </div>
        <div class="content">
          <div class="item">
            <p>最高额度</p>
            <h3> {{ productData.maxAmount }}万</h3>
          </div>
          <div class="item">
            <p>最长期限</p>
            <h3>{{ productData.repayTerm }}个月</h3>
          </div>
        </div>
      </div>

      <div class="main">
        <div class="title">
          <p>产品简介</p>
        </div>

        <ul>
          <li>
            <div class="icon">
              <img :src="icon2" alt="">
            </div>
            <h3>贷款额度</h3>
            <p>0-{{ productData.maxAmount }}万</p>
          </li>
          <li>
            <div class="icon">
              <img :src="icon1" alt="">
            </div>
            <h3>{{ changeRate }}{{ productData.rateDesc ? `(${productData.rateDesc})` : '' }}</h3>
            <p>{{ productData.rate }}%起</p>
          </li>
          <li>
            <div class="icon">
              <img :src="icon3" alt="">
            </div>
            <h3>借款期限</h3>
            <p>{{ reduceLoanTerm }}</p>
          </li>
          <li>
            <div class="icon">
              <img :src="icon4" alt="">
            </div>
            <h3>还款方式</h3>
            <p>{{ productData.repayType ? productData.repayType.replaceAll(',', '/') : '' }}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer">
      <div class="button" @click="canApply">立即申请</div>
    </div>

    <div class="loadingBox" v-if="IsloadingBox">
      <Loading accountFont="数据请求中，请稍后..." size="120" color="#eee" type="spinner">数据请求中，请稍后...</Loading>
    </div>

    <!-- 弹框 -->
    <Notification v-if="show" :isShow="show"></Notification>
  </div>
</template>
<script>
import { addressIphone } from '@/utils';
import Notification from './components/Notification.vue';
import Loading from '@/components/Loading.vue';
import icon1 from '@/assets/images/product-icon1.png'
import icon2 from '@/assets/images/product-icon2.png'
import icon3 from '@/assets/images/product-icon3.png'
import icon4 from '@/assets/images/product-icon4.png'

export default {
  name: 'productDetail',
  data() {
    return {
      show: false,
      productData: {},
      IsloadingBox: false,
      productId: '',
      ShowContent: '',
      repayTypeArr: [],
      orderId: '',
      active: '',
      status: '',
      tabsList: ['申请条件', '资料准备', '开放城市'],
      icon1,
      icon2,
      icon3,
      icon4
    };
  },
  components: {
    Loading,
    Notification
  },
  mounted() {
    addressIphone();
    this.productId = this.$route.query.productId || '';
    this.getDataList();
  },
  computed: {
    changeRate() {
      const { rateCategory } = this.productData;
      if (rateCategory === '0') return '日利率';
      if (rateCategory === '1') return '月利率';
      if (rateCategory === '2') return '年化利率';
      return '日利率';
    },
    reduceLoanTerm() {
      let res = ''
      this.productData?.repayTermArray?.forEach(item => {
        res += (item + '/')
      });
      return res.slice(0, res.length - 1) + '个月'
    },
  },
  methods: {
    getDataList() {
      this.$api.PublicPage.getproductList().then((res) => {
        if (res.success) {
          const item = res.data.list.filter((e) => e.productId === this.productId)[0];
          if (!item) {
            return this.show = true
          }
          this.productData = item;
          this.repayTypeArr = item.repayType ? item.repayType.split(',') : [];
        }
      });
    },
    canApply() {
      // sessionStorage.setItem('PRODUCT_ID', this.productId);
      window.location.href = `/backloansuper/loan/supermarket/login2Url/v1.0?k=perfect&productId=${this.productId}`;
    },
  },
};
</script>
<style scoped>
.productDetailBox {
  background-color: #fff;
  background-image: linear-gradient(180deg, rgba(255, 101, 56, 0.05) 0%, rgba(255, 255, 255, 0.10) 80%);
}

.continer {
  background: url(../../../../assets/images/productDetailTopBg.png) no-repeat;
  background-size: 100% 220px;
  padding: 16px 16px 80px;
}

.continer .top {}

.continer .top .productDetail {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 16px;
}

.continer .top .productDetail p {
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 32px;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.20);
  font-weight: 600;
  margin: 0px 15px 0px;
}

.continer .top .productDetail .pics {
  width: 64px;
  height: 64px;
  box-sizing: border-box;
  padding: 8px;
  background: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.02), 0px 9px 28px 8px rgba(0, 0, 0, 0.02);
  border-radius: 16px;
}

.continer .top .productDetail .pics img {
  width: 100%;
  height: 100%;
}

.continer .top .content {
  display: flex;
  background-image: linear-gradient(0deg, rgba(255, 223, 218, 0) 0%, rgba(255, 172, 130, 0.4) 100%);
  box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, .4), 0px 1px 3px 0px rgba(245, 143, 93, .4);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  padding: 32px 0px;
}

.continer .top .content .item {
  position: relative;
  width: 50%;
  text-align: center;
}

.continer .top .content .item:nth-child(1)::after {
  content: '';
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  height: 32px;
  border-right: 1px solid rgba(255, 255, 255, 0.65);
}

.continer .top .content .item p {
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 22px;
  font-weight: 600;
  margin: 0px;
}

.continer .top .content .item h3 {
  font-family: PingFangSC-Semibold;
  font-size: 32px;
  color: #FFFFFF;
  text-align: center;
  line-height: 40px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.13);
  font-weight: 600;
  margin: 0px;
}

.continer .main {
  margin-top: 30px;
}

.continer .main .title {
  display: flex;
  justify-content: center;
}

.continer .main .title p {
  position: relative;
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #141414;
  line-height: 28px;
  font-weight: 600;
  margin-bottom: 8px;
  z-index: 1;
}

.continer .main .title p::after {
  content: '';
  position: absolute;
  bottom: 2px;
  left: 0px;
  height: 7px;
  width: 100%;
  background-color: rgb(253, 91, 50);
  z-index: -1;
  clip-path: polygon(0 0, 100% 0%, 100% 70%, 0% 100%);
}

.continer .main ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.continer .main li {
  width: 47.8%;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.02), 0px 9px 28px 8px rgba(0, 0, 0, 0.02);
  border-radius: 16px;
  padding: 20px 0px;
  text-align: center;
  margin-top: 16px;
}

.continer .main li .icon {
  position: relative;
  width: 24px;
  height: 24px;
  margin: 0 auto;
}

.continer .main li .icon img {
  position: relative;
  z-index: 1;
}

.continer .main li .icon::before {
  content: '';
  position: absolute;
  width: 7px;
  height: 7px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  filter: blur(3px);
  background: rgba(255, 101, 56);
  -webkit-backdrop-filter: blur(4px);
  filter: blur(4px);
  backdrop-filter: blur(4px);
  border-radius: 50%;
  z-index: 0;
}

.continer .main li h3 {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #141414;
  line-height: 24px;
  font-weight: 600;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 4px;
}

.continer .main li p {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #8C8C8C;
  line-height: 20px;
  font-weight: 400;
  margin: 0px;
}

.productDetailBox .footer {
  position: fixed;
  bottom: 0px;
  padding: 8px 16px;
  border-top: 1px solid #F5F5F5;
  width: calc(100% - 32px);
}

.productDetailBox .footer .button {
  width: 100%;
  background: #FF6538;
  border-radius: 8px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 40px;
  font-weight: 600;
}
</style>
